import React from "react";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../constants/forms";
import { formsLabelType } from "../../../enums/index";

const PartOne = (props) => {
  const changeValue = (e) => {
    const { name, value } = e.target;
    props.setEditInfo({ ...props.editInfo, [name]: value });
  };

  return (
    <>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Name())}:
          </Form.Label>
          <Form.Control
            className={`${
              props?.isEditMood ? "user-info-from form-control" : "normal-input"
            }`}
            type="text"
            value={
              !props?.isEditMood
                ? props.customer.FirstName
                : props.editInfo.FirstName
            }
            onChange={(e) => {
              props.setEditInfo({
                ...props.editInfo,
                FirstName: e.target.value,
              });
            }}
            disabled={!props?.isEditMood}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Family())}:
          </Form.Label>
          <Form.Control
            className={`${
              props?.isEditMood ? "user-info-from form-control" : "normal-input"
            }`}
            type="text"
            value={
              !props?.isEditMood
                ? props.customer.LastName
                : props.editInfo.LastName
            }
            onChange={(e) => {
              props.setEditInfo({
                ...props.editInfo,
                LastName: e.target.value,
              });
            }}
            disabled={!props?.isEditMood}
          />
        </Form.Group>
        :
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.FatherName())}:
          </Form.Label>
          <Form.Control
            className={`${
              props?.isEditMood ? "user-info-from form-control" : "normal-input"
            }`}
            type="text"
            value={
              !props?.isEditMood
                ? props.customer.FathersName
                : props.editInfo.FatherName
            }
            onChange={(e) => {
              props.setEditInfo({
                ...props.editInfo,
                FatherName: e.target.value,
              });
            }}
            disabled={!props?.isEditMood}
          />
        </Form.Group>
        <Form.Group
          as={Col}
          className={`${props.isEditMood ? "d-flex flex-row " : ""}`}
        >
          <Form.Label className="input-label form-label">
            {FormTexts.Labels(formsLabelType.Gender())}:
          </Form.Label>
          {!props.isEditMood ? (
            <Form.Control
              className="normal-input"
              type="text"
              value={
                props.customer.Gender && FormTexts.Gender(props.customer.Gender)
              }
              onChange={() => console.log("")}
            />
          ) : (
            <select
              className="user-info-from-select"
              name="Gender"
              value={props?.editInfo?.Gender}
              onChange={(e) => {
                props.setEditInfo({
                  ...props.editInfo,
                  Gender: e.target.value,
                });
              }}
            >
              <option value="1">زن</option>
              <option value="2">مرد</option>
            </select>
          )}
        </Form.Group>
      </Row>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.NationalCode())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.NationalCode ? props.customer.NationalCode : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.BirthDay())}:
          </Form.Label>
          <Form.Control
            className={`${
              props?.isEditMood ? "user-info-from form-control" : "normal-input"
            }`}
            type="text"
            value={
              !props?.isEditMood
                ? props.customer.BirthDate?.split(" ")[0]
                : props.editInfo.BirthDate?.split(" ")[0]
            }
            onChange={(e) => {
              props.setEditInfo({
                ...props.editInfo,
                BirthDate: e.target.value,
              });
            }}
            disabled={!props?.isEditMood}
          />
        </Form.Group>
      </Row>
    </>
  );
};
export default PartOne;
